// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
/* Greif Custom Code
import DataViewLoadingOverlay, {
    DataViewLoadingOverlayProps,
} from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
*/
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { baseGridProps } from "@store/Themes/common/props/baseGrid";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

/* Greif Custom Code - Start */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState, isCartEmpty } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import DataViewLoadingOverlay, {
    DataViewLoadingOverlayProps,
} from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import { connect } from "react-redux";
/* Greif Custom Code - End */

export interface OwnProps extends ExpandStyles<OrderLayoutStyles>, DataViewLoadingOverlayProps {
    id: string;
    // Greif
    displayLoadingText?: boolean;
    loadingText?: string;
    isPlacingOrder?: boolean;
    displayAdditionalMessage?: boolean;
    additionalMessageText?: string;
}

export interface OrderLayoutStyles {
    loadingOverlay?: LoadingOverlayProps;
    container?: GridContainerProps;
    mainColumn?: GridItemProps;
    sideColumnMobile?: GridItemProps;
    sideColumnDesktop?: GridItemProps;
    sideColumnWrapper?: InjectableCss;
    /* Greif Custom Code */

    contentContainer?: GridContainerProps;
    addToCartRow?: GridItemProps;
    cartMainContent?: GridItemProps;
}

export const orderLayoutStyles: OrderLayoutStyles = {
    loadingOverlay: { minHeight: 150 },
    container: baseGridProps.container,
    mainColumn: {
        width: [12, 12, 7, 8, 9],
        printWidth: 12,
    },
    sideColumnMobile: {
        width: [12, 12, 0, 0, 0],
        printWidth: 0,
    },
    sideColumnDesktop: {
        width: [0, 0, 5, 4, 3],
        printWidth: 12,
    },
    sideColumnWrapper: {
        css: css`
            position: sticky;
            top: ${pxToRem(75 + 20)}; /* Greif Custom Code - Add an extra 75 pixels to handle the sticky */
            width: 100%;
        `,
    },
    /* Greif Custom Code - Start */
    contentContainer: {
        isFullWidth: true,
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
        `,
    },
    addToCartRow: {
        width: [12, 12, 12, 12, 11],
    },
    cartMainContent: {
        width: 12,
    },
    /* Greif Custom Code - End */
};
/* Greif Custom Code - Start */
const mapStateToProps = (state: ApplicationState) => {
    const cart = getCurrentCartState(state).value;
    return {
        isCartEmpty: isCartEmpty(cart),
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;
/* Greif Custom Code - End */

const OrderLayout: FC<Props> = ({
    // Greif Custom Code
    id,
    loading,
    loadComplete,
    dataView,
    preload,
    extendedStyles,
    overridedStyles,
    // Greif
    loadingText,
    displayLoadingText,
    isPlacingOrder,
    displayAdditionalMessage,
    additionalMessageText,
    isCartEmpty,
}) => {
    const styles = useExpandProps(orderLayoutStyles, extendedStyles, overridedStyles);

    return (
        <DataViewLoadingOverlay
            dataView={dataView}
            loading={loading}
            loadComplete={loadComplete}
            preload={preload}
            {...styles.loadingOverlay}
            // Greif
            loadingText={loadingText}
            displayLoadingText={displayLoadingText}
            isPlacingOrder={isPlacingOrder}
            displayAdditionalMessage={displayAdditionalMessage}
            additionalMessageText={additionalMessageText}
        >
            <GridContainer {...styles.container}>
                <GridItem {...styles.sideColumnMobile}>
                    <Zone contentId={id} zoneName="Side" />
                </GridItem>
                <GridItem {...styles.mainColumn}>
                    {/* Greif Custom Code - Start */}
                    <GridContainer {...styles.contentContainer}>
                        <GridItem {...styles.addToCartRow}>
                            {isCartEmpty && <Zone contentId={id} zoneName="addToCartEmpty" /> /* Greif Custom Code */}
                        </GridItem>
                        <GridItem {...styles.cartMainContent}>
                            <Zone contentId={id} zoneName="Content" />
                        </GridItem>
                    </GridContainer>
                    {/* Greif Custom Code - End */}
                </GridItem>
                <GridItem {...styles.sideColumnDesktop}>
                    <StyledWrapper {...styles.sideColumnWrapper}>
                        <Zone contentId={id} zoneName="Side" />
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </DataViewLoadingOverlay>
    );
};

export default connect(mapStateToProps)(OrderLayout);
